/**
 * Builds the BuyerInput for @inContext from the current B2B company location
 * and the logged-in customer's access token. Returns null when either is
 * missing (storefront falls back to default market pricing).
 * @returns {{ customerAccessToken: string, companyLocationId: string } | null}
 */
export default function getBuyer() {
  const locationId = window.theme.location_id;

  if (!locationId) return null;

  const customerAccessData = localStorage.getItem("customer-access-data");
  const { access_token } = customerAccessData
    ? JSON.parse(customerAccessData)
    : { access_token: null };

  if (!access_token) return null;

  return {
    customerAccessToken: access_token,
    companyLocationId: `gid://shopify/CompanyLocation/${locationId}`,
  };
}
